/** Served from public/img — copied to dist on build */
export const galleryTiles = [
  {
    id: "icedDrinks",
    type: "image",
    image: "/img/gallery/mizu-jeges-italok.jpg",
  },
  {
    id: "coffeeVideo",
    type: "video",
    // Light 720p clip for the tile preview, full quality in the lightbox.
    preview: "/img/mizu-hero.mp4",
    video: "/img/mizu.mp4",
    poster: "/img/mizu-hero-poster.jpg",
  },
  {
    id: "showcase",
    type: "image",
    image: "/img/gallery/mizu-vitrin.jpg",
  },
  {
    id: "kitchenVideo",
    type: "video",
    preview: "/img/gallery/mizu-konyha.mp4",
    video: "/img/gallery/mizu-konyha.mp4",
    poster: "/img/gallery/mizu-konyha-poster.jpg",
  },
  {
    id: "cocktails",
    type: "image",
    image: "/img/gallery/mizu-koktelok.jpg",
  },
];
